import { Component, OnInit, computed, Signal } from '@angular/core';
import { AppInitializerService, InitializationStatus } from '../../../services/app-initializer.service';

@Component({
  selector: 'app-app-loading',
  templateUrl: './app-loading.component.html',
  styleUrls: ['./app-loading.component.scss'],
})
export class AppLoadingComponent implements OnInit {
  initializationStatus: Signal<InitializationStatus>;
  initializationError: Signal<string | null>;
  currentLoadingStep: Signal<string>;
  isLoading: Signal<boolean>;
  hasError: Signal<boolean>;

  constructor(private appInitializer: AppInitializerService) {
    this.initializationStatus = this.appInitializer.initializationStatus;
    this.initializationError = this.appInitializer.initializationError;
    this.currentLoadingStep = this.appInitializer.currentLoadingStep;
    this.isLoading = computed(() => this.initializationStatus() === 'loading');
    this.hasError = computed(() => this.initializationStatus() === 'error');
  }

  ngOnInit() {}

  retryInitialization() {
    this.appInitializer.resetInitialization();
    this.appInitializer.initializeApp().catch(error => {
      console.error('Retry initialization failed:', error);
    });
  }
}
